<template>
  <div>
    <div class="text-left" v-if="financialPerformance.country && financialPerformance.country.toLowerCase() == 'india'">
      <div class="pb-2 ml-4 mt-2">
        <div class="row">
          <div class="col-sm">Current debt outstanding (in lakhs)</div>
          <div class="col-sm">{{financialPerformance.currentDebtOutStanding}}</div>
        </div>
      </div>
      <div class="pb-2 ml-4 mt-2">
        <div class="row">
          <div class="col-sm">Debt to asset ratio</div>
          <div class="col-sm">{{financialPerformance.debtToAssesRatio}}</div>
        </div>
      </div>
      <div class="pb-2 ml-4 mt-2">
        <div class="row">
          <div class="col-sm">Current assets to Current liabilities</div>
          <div class="col-sm">{{financialPerformance.assetsToLiabilityratio}}</div>
        </div>
      </div>
      <div class="pb-3 ml-4 mt-2">
        <div class="row">
          <div class="col-sm">Average Working Capital</div>
          <div class="col-sm">{{financialPerformance.averageCapitalPercentage}}</div>
        </div>
      </div>
    </div>

    <div>
      <div
        class="pb-3"
        v-if="financialPerformance.financialYearDetails && financialPerformance.financialYearDetails.length > 0"
      >
        <div class="inner-title col">Financial Year Performance</div>
        <div class="table-wrapper-scroll-y my-custom-scrollbar">
          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th scope="col">Sl No</th>
                <th scope="col">Financial Year</th>
                <th scope="col">Assets</th>
                <th scope="col">Gross Profit</th>
                <th scope="col">Net Profit</th>
                <th scope="col">RoA</th>
                <th scope="col">RoCE</th>
                <th scope="col">Turnover</th>
                <th scope="col">ITR Date</th>
                <th scope="col">ITR Ack.no</th>
              </tr>
            </thead>
            <tbody class="text-left">
              <tr
                v-for="(financialYear,index) in financialPerformance.financialYearDetails"
                :key="index"
              >
                <td scope="col">{{index+1}}</td>
                <td scope="col">{{financialYear.year}}-{{financialYear.year+1}}</td>
                <td scope="col">{{financialYear.assets}}</td>
                <td scope="col">{{financialYear.grossProfit}}</td>
                <td scope="col">{{financialYear.netProfit}}</td>
                <td scope="col">{{financialYear.roa}}</td>
                <td scope="col">{{financialYear.roce}}</td>
                <td scope="col">{{financialPerformance.currencyType.shortDesc}} {{financialYear.turnover}} {{financialPerformance.currencyUnitType.shortDesc}}</td>
                <td scope="col">{{financialYear.itrDate}}</td>
                <td scope="col">{{financialYear.itrReference}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["financialPerformance", "organizationDetail"]
};
</script>
<style scoped>
.inner-title {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  font-stretch: normal;
  line-height: 1.25;
  text-align: left;
  padding-bottom: 1%;
  /* width: 246px;
  height: 36px; */
  /* font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.06;
  letter-spacing: 0.16px;
  text-align: left;
  color: #000000; */
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky;
  color: #fff;
  text-align: left;
}
/* .my-custom-scrollbar {
  position: relative;
  height: 150px;
  width: 100%;
  overflow: auto;
} */
</style>